import { ALL_BUTTON_POSITION_LIST } from '@/common/manager/position/button-position';
import { getRealizeValue, executeObjectExpr, getRunTimeItem, getItem, executeFunction, } from '@/common/util/util';
import { ActionRunEnv } from '@/common/util/action-run-env';
import isUndefined from 'lodash/isUndefined';
import { __dataSource__ } from '@/common/util/expr-const';
import { getButtonAction } from '../../button';
export const config = {
    value: 'pollingAction',
    position: ALL_BUTTON_POSITION_LIST,
    action: async (config, ...otherArgs) => {
        const { buttonConfig, position, _context, getFlowActionInfo, actionRunEnv, } = config || {};
        const { options, optType: fromOptType } = buttonConfig || {};
        const { pollingItem, checkIsEnd, interval } = options;
        async function executeFlowListInPolling(list) {
            let isStop = false;
            const result = [];
            while (!isStop) {
                for (const index in list) {
                    const item = list[index];
                    const { active, optType } = item || {};
                    const isActive = executeObjectExpr(active, {
                        [__dataSource__]: _context?.state,
                    }, {}, _context?.state);
                    if (isActive === true) {
                        let action = getButtonAction({
                            ...item,
                            position,
                        });
                        if (!action) {
                            const componentDefine = getRunTimeItem(optType);
                            const component = getRealizeValue(componentDefine?.component);
                            if (typeof component?.action === 'function') {
                                action = component.action;
                            }
                        }
                        let flowResult;
                        if (typeof action === 'function') {
                            flowResult = await action({
                                needSuccessToast: false,
                                ...config,
                                buttonConfig: { ...item },
                                // 动作执行的环境
                                actionRunEnv: 'pollingAction',
                                getFlowActionInfo: () => {
                                    return {
                                        pollingItem,
                                        currentFlowIndex: index,
                                    };
                                },
                            }, ...otherArgs);
                        }
                        const handleFlowResult = getItem(position, optType, 'handleFlowResult');
                        if (typeof handleFlowResult === 'function') {
                            flowResult = handleFlowResult(flowResult);
                        }
                        if (flowResult && _context) {
                            let realIndex = +index;
                            if (realIndex === 0) {
                                realIndex = '';
                            }
                            // _context.state.valueOf.polling = {
                            //   ...(_context.state.valueOf.polling ?? {}),
                            //   [optType + realIndex]: flowResult,
                            // }
                            // 仅动作编排触发该动作时，需要区分是哪个轮询操作结果
                            if (actionRunEnv === ActionRunEnv.flowAction) {
                                const parentIndex = fromOptType === 'pollingAction'
                                    ? +getFlowActionInfo?.()?.currentFlowIndex
                                    : '';
                                _context.state.valueOf[`polling${parentIndex || ''}_${optType}${realIndex}`] = flowResult;
                            }
                            else {
                                _context.state.valueOf[optType + realIndex] = flowResult;
                            }
                        }
                        !isUndefined(flowResult) && result.push(flowResult);
                        if (!isStop) {
                            isStop = executeFunction(checkIsEnd, flowResult, _context?.state);
                        }
                    }
                }
                if (!isStop) {
                    await waitAsync(interval ? interval * 1000 : 2000);
                }
            }
            return result[result.length - 1];
        }
        if (Array.isArray(pollingItem) && pollingItem.length > 0) {
            // if (_context?.state) {
            //   const flowDataKeys = Object.keys(_context.state.valueOf);
            //   if (Array.isArray(flowDataKeys) && flowDataKeys.length > 0) {
            //     flowDataKeys.forEach((key) => {
            //       if (key) {
            //         if (key.includes('$$$') || key.startsWith('Cn')) {
            //         } else {
            //           // _context.state.valueOf[key] = undefined;
            //         }
            //       }
            //     });
            //   }
            // }
            return await executeFlowListInPolling(pollingItem);
        }
    },
};
function waitAsync(time) {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(true);
        }, time);
    });
}
